export default (key, type, sessionManager) => {
  switch (type) {
    case 'user':
      return `${sessionManager?.user?.id}_${key}`;
    case 'tenant':
      return `${sessionManager?.tokenMetadata?.tenant}_${key}`;
    default:
      return key;
  }
};
